<template>
  <div ref="test" class="test">
    <ul>
      <template v-for="(item, i) in cacheList">
        <li
          :id="'factoryTip-' + i"
          v-if="winPos[i] && winPos[i][0] && winPos[i][3]"
          :key="i"
          class="ComponentTipLi"
          :style="{
            left: winPos[i][0] / prew + 'px',
            bottom: winPos[i][3] / prew + 10 + 30 + 'px',
            zIndex: item.zIndex ? item.zIndex : 0,
          }"
        >
          <div
            :class="{
              ComponentTip: true,
              isSelected: getSelectedClass(i),
              defaultClass: getDefaultFactoryClass(i),
            }"
            @mouseenter="componentEnter(item, i)"
            @mousemove="componentEnter(item, i)"
            @mouseleave="componentOut(item, i)"
            @click="gotoFactoryArea(item)"
          >
            <div class="Component_detailInfo">
              <div class="component_up">
                <table class="component_table">
                  <tr>
                    <th style="color: #f5a623">排放源类型</th>
                    <th>排放源点</th>
                    <th>关联生产设备</th>
                    <th>关联监测设备</th>
                    <th>关联治理设备</th>
                    <th>治理设备开启</th>
                  </tr>
                  <tr
                    v-for="(item_, i_) in item.emmissionData"
                    v-bind:key="'emission' + i_"
                  >
                    <td
                      v-for="(item__, i__) in item_"
                      v-bind:key="'emissionDetail' + i__"
                    >
                      {{ item__ }}
                    </td>
                  </tr>
                </table>
              </div>
              <div class="component_down">
                <div class="component_tip">“-”表示无需关联</div>
                <div class="component_rank">
                  <span style="color: #f5a623">室内</span>
                  <span>环境水平:NO.{{ item.innerRank }}</span>
                  <span style="margin-left: 10px; color: #f5a623">室外</span>
                  <span>环境水平:NO.{{ item.outerRank }}</span>
                </div>
                <div
                  @click="gotoFactoryAreaDetail(item.type)"
                  class="component_btn"
                  style="right: 100px"
                >
                  查看相关排放源
                </div>
                <div @click.stop="close()" class="component_btn">关闭</div>
              </div>
            </div>
            <p>
              {{ item.title
              }}<span :style="{ marginLeft: '50px' }">{{
                item.branchCount
              }}</span>
            </p>
            <!--p :style="{ padding: '2px', fontWeight: 'normal' }">
            室内环境水平居全厂:
            <span :style="{ color: '#65f5f2' }">NO.{{ item.innerRank }}</span>
          </p>
          <p :style="{ padding: '2px', fontWeight: 'normal' }">
            室外环境水平居全厂:
            <span :style="{ color: 'gold' }">NO.{{ item.outerRank }}</span>
          </p-->
            <div class="arrow_down"></div>
          </div>
          <img
            style="margin-top: 20px; margin-left: -35px"
            src="./img/factoryPoint.png"
          />
        </li>
      </template>
    </ul>

    <ul>
      <template v-for="(item, i) in cacheList_">
        <li
          :id="'MaterialTip-' + i"
          v-if="
            winPos[i + cacheList.length] &&
            winPos[i + cacheList.length][0] &&
            winPos[i + cacheList.length][3]
          "
          class="ComponentTipLi"
          :key="i + cacheList.length"
          :style="{
            left: isUnity3D
              ? winPos[i + cacheList.length][0] + 'px'
              : winPos[i + cacheList.length][0] / prew + 'px',
            bottom: isUnity3D
              ? winPos[i + cacheList.length][3] + 'px'
              : winPos[i + cacheList.length][3] / prew + 10 + 30 + 'px',
            height: '120px',
            zIndex: item.zIndex ? item.zIndex : 0,
          }"
        >
          <div
            :class="{
              ComponentTip: true,
              isSelected: getSelectedMaterialClass(i),
            }"
            @click="gotoMaterialArea(item)"
          >
            <!--span>{{ item.title }}</span>
          <img src="./img/material.png" /-->
            <p>
              {{ item.shedName }}<span :style="{ marginLeft: '50px' }"></span>
            </p>
            <!--p :style="{ padding: '2px', fontWeight: 'normal' }">
            室内环境水平居全厂:
            <span :style="{ color: '#65f5f2' }">NO.{{ item.innerRank }}</span>
          </p>
          <p :style="{ padding: '2px', fontWeight: 'normal' }">
            室外环境水平居全厂:
            <span :style="{ color: 'gold' }">NO.{{ item.outerRank }}</span>
          </p-->
            <div class="arrow_down"></div>
          </div>
          <img
            style="margin-top: 20px; margin-left: -35px"
            src="./img/shedPoint.png"
          />
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { mapState, mapGetters } from "vuex";
//import { initScene } from "./science.js";
import { unref } from "vue";

import {
  GetScreenPosFunc,
  CameraMove,
  GetScreenPosYGFunc,
  ShowPointFun,
  ShowFocusPointFun,
  CloseFocusPointFun,
  CamLeapYGFunc
} from "@/assets/js/unity3D/index.js";

export default {
  //import引入的组件需要注入到对象中才能使用
  props: {},
  inject: [
    "getSourceData",
    "updateSourceData",
    "getFactoryArea",
    "getBranchFactoryList",
    "getMaterialShedList",
    "updateMaterialShedList",
    "updateSourceShow",
    "updateFactoryArea",
    "updateMaterialArea",
    "updateVdmArea",
    "updateLeftRightPart",
    "updateInventorySwitch",
    "updateInventoryId",
    "getShedObj",
    "updateKeyPointInfoPosition",
    "getShedList",
  ],
  data() {
    //这里存放数据
    return {
      customerId: this.$store.state.customerId,
      cacheList: [],
      cacheList_: [],
      winPos: [], //排放源点的定位
      shedObj: {},
      factoryTimer: "",
      altitude: 0,
      flyAltitude: 0,
      selectedFactory: "",
      hoverFactory: "",
      selectedMaterial: "",
      flyingStates: "",
      getScreenTimer: null,
      isUnity3D: false,
      TCposition: undefined,
      shedList: [],
      currentMapId: "158", //为了加载标牌，先加载一个固定区域，区域id  158
    };
  },
  //计算属性 类似于data概念
  computed: {
    ...mapState({ prew: "scaleValue" }),
    titleViews() {
      return this.$store.state.titleViews;
    },
    currentKeyPointName() {
      return this.$store.state.currentKeyPointName;
    },
    getSelectedClass: function () {
      return function (i) {
        let valid = false;
        if (
          !(this.selectedFactory || this.hoverFactory) &&
          !this.selectedMaterial
        ) {
          valid = false;
        } else if (this.selectedFactory || this.hoverFactory) {
          if (
            this.selectedFactory === "factoryTip-" + i ||
            this.hoverFactory === "factoryTip-" + i
          ) {
            valid = true;
          } else {
            valid = false;
          }
        }
        return valid;
      };
    },
    getDefaultFactoryClass: function () {
      return function (i) {
        let valid = false;
        if (
          this.selectedFactory &&
          this.selectedFactory !== "factoryTip-" + i
        ) {
          valid = false;
        } else {
          valid = true;
        }
        return valid;
      };
    },
    getSelectedMaterialClass: function () {
      return function (i) {
        let valid = false;
        if (!this.selectedFactory && !this.selectedMaterial) {
          valid = true;
        } else if (this.selectedMaterial) {
          if (i === 0) {
            valid = true;
          } else {
            valid = false;
          }
        }
        return valid;
      };
    },
  },
  //监控data中的数据变化
  watch: {
    /*getFactoryArea: {
      handler(newVal, oldVal) {
        console.log(unref(newVal));
        let valid = unref(newVal);
        if (valid) {
          $(this.$refs.test).find("li").fadeOut(1000);
        } else {
          $(this.$refs.test).find("li").fadeIn(1000);
        }
      },
      deep: true,
    },*/
    flyingStates: {
      handler(newVal, oldVal) {},
      deep: true,
    },
    "$store.state.dbMaterialObj": {
      handler(newVal) {
        if(newVal) {
          this.gotoMaterialArea(newVal);
        }
      },
      deep: true
    },
    "$store.state.unorganizedRecover": {
      handler(newVal, oldVal) {
        //alert(newVal);
        this.selectedFactory = "";
        this.selectedMaterial = "";
        this.hoverFactory = "";
        this.$forceUpdate();

        try {
          const earth = window.g_bme3dManager.earth;
          this.flyingStates = window.g_bme3dManager.earth.camera.flying;
          let view = mapViews[`mapViews_${this.customerId}`].unOrganizedMod;
          let cesuimFly = earth.camera.flyTo(
            view[0],
            view[1],
            view[2],
            view[3],
            function () {
              alert(2222222222);
            }
          );
          let that = this;
          if (that.recoverTimer) {
            clearTimeout(that.recoverTimer);
          } else {
            that.recoverTimer = setTimeout(function () {
              that.$nextTick(function () {
                if ($(".ComponentTip").length > 0) {
                  for (let i = 0; i < $(".ComponentTip").length; i++) {
                    let jqNode = $($(".ComponentTip").get(i));
                    let w = jqNode.outerWidth();
                    jqNode.css("marginLeft", -w / 2 + "px");
                    jqNode.find(".arrow_down").css("left", w / 2 - 20 + "px");
                  }
                }
              });
            }, (view[3] + 1) * 1000);
          }
        } catch (err) {
          console.log(err);
        }
      },
      deep: true,
    },
    getShedObj: {
      handler(newVal, oldVal) {
        this.shedObj = unref(newVal);
        if (!this.shedObj) {
          return;
        }
        if (
          $("#shedSampledata").length > 0 &&
          $("#shedSampledata").is(":visible")
        ) {
          this.gotoMaterialArea(this.shedObj);
        } else {
          this.selectedMaterial = true;
          if (window.g_bme3dManager && bmeConfig.mapType != "unity3D") {
            try {
              this.cacheList_[0] = this.shedObj;
              this.drawTip(
                "MaterialTip-" + 0,
                this.shedObj.longitude,
                this.shedObj.latitude,
                50,
                0 + this.cacheList.length,
                g_bme3dManager.earth
              );
              this.$forceUpdate();

              /*(JSON.stringify(this.cacheList_));
        alert(JSON.stringify(this.winPos));*/

              let flyArg = JSON.parse(
                g_bme3dManager.earth.camera.toAllJSONStr()
              );

              const earth = window.g_bme3dManager.earth;

              earth.camera.flyTo(
                [
                  (this.shedObj.longitude * Math.PI) / 180.0,
                  (this.shedObj.latitude * Math.PI) / 180.0,
                  this.altitude + 45,
                ],
                this.flyAltitude + 450,
                flyArg.rotation,
                1
              );

              let that = this;
              if (that.goShedTimer) {
                clearTimeout(that.goShedTimer);
              } else {
                that.goShedTimer = setTimeout(function () {
                  that.$nextTick(function () {
                    if ($(".ComponentTip").length > 0) {
                      for (let i = 0; i < $(".ComponentTip").length; i++) {
                        let jqNode = $($(".ComponentTip").get(i));
                        let w = jqNode.outerWidth();
                        jqNode.css("marginLeft", -w / 2 + "px");
                        jqNode
                          .find(".arrow_down")
                          .css("left", w / 2 - 20 + "px");
                      }
                    }
                  });
                }, (1 + 1) * 1000);
              }
            } catch (err) {
              console.log(err);
            }
          } else {
            this.moveToShed();
          }
        }

        this.$nextTick(function () {
          if ($(".ComponentTip").length > 0) {
            for (let i = 0; i < $(".ComponentTip").length; i++) {
              let jqNode = $($(".ComponentTip").get(i));
              let w = jqNode.outerWidth();
              jqNode.css("marginLeft", -w / 2 + "px");
              jqNode.find(".arrow_down").css("left", w / 2 - 20 + "px");
            }
          }
        });
        //this.init();
      },
      deep: true,
    },
    getBranchFactoryList: {
      handler(newVal, oldVal) {
        let newList = unref(newVal);
        let cacheList = new Array();

        newList &&
          newList.forEach((element, i) => {
            let emmissionData = [];
            if (element.branchIdType && element.branchIdType.length > 0) {
              element.branchIdType.forEach((item) => {
                let tmpData = ["-", "-", "-", "-", "-", "-"];
                let tmpType = item.type;
                if (tmpType) {
                  tmpData[0] = item.emission_source_type;
                  tmpData[1] = item.count;

                  if (!$.isEmptyObject(tmpType)) {
                    tmpType.forEach((item_) => {
                      if (item_.primary_type_name == "生产设备") {
                        tmpData[2] = item_.count;
                      } else if (item_.primary_type_name == "治理设备") {
                        tmpData[3] = item_.count;
                        tmpData[5] = item_.onLine;
                      } else if (item_.primary_type_name == "监测设备") {
                        tmpData[4] = item_.count;
                      }
                    });
                  }
                  emmissionData.push(tmpData);
                }
              });
              if (emmissionData.length < 4) {
                let delta = 4 - emmissionData.length;
                for (let i = 0; i < delta; i++) {
                  emmissionData.push(["", "", "", "", "", ""]);
                }
              }
            } else {
              emmissionData = [
                ["-", "-", "-", "-", "-"],
                ["-", "-", "-", "-", "-"],
                ["-", "-", "-", "-", "-"],
                ["-", "-", "-", "-", "-"],
              ];
            }

            if (element.branch === "炼铁厂") {
              if (bmeConfig.branchObj && bmeConfig.branchObj["炼铁厂"]["lng"]) {
                element.longitude = bmeConfig.branchObj["炼铁厂"]["lng"];
              }
              if (bmeConfig.branchObj && bmeConfig.branchObj["炼铁厂"]["lat"]) {
                element.latitude = bmeConfig.branchObj["炼铁厂"]["lat"];
              }
            } else if (element.branch === "炼钢厂") {
              if (bmeConfig.branchObj && bmeConfig.branchObj["炼钢厂"]["lng"]) {
                element.longitude = bmeConfig.branchObj["炼钢厂"]["lng"];
              }
              if (bmeConfig.branchObj && bmeConfig.branchObj["炼钢厂"]["lat"]) {
                element.latitude = bmeConfig.branchObj["炼钢厂"]["lat"];
              }
            } else if (element.branch === "烧结厂") {
              if (bmeConfig.branchObj && bmeConfig.branchObj["烧结厂"]["lng"]) {
                element.longitude = bmeConfig.branchObj["烧结厂"]["lng"];
              }
              if (bmeConfig.branchObj && bmeConfig.branchObj["烧结厂"]["lat"]) {
                element.latitude = bmeConfig.branchObj["烧结厂"]["lat"];
              }
            } else if (element.branch === "原料厂") {
              if (bmeConfig.branchObj && bmeConfig.branchObj["原料厂"]["lng"]) {
                element.longitude = bmeConfig.branchObj["原料厂"]["lng"];
              }
              if (bmeConfig.branchObj && bmeConfig.branchObj["原料厂"]["lat"]) {
                element.latitude = bmeConfig.branchObj["原料厂"]["lat"];
              }
            } else if (element.branch === "发电厂") {
              if (bmeConfig.branchObj && bmeConfig.branchObj["发电厂"]["lng"]) {
                element.longitude = bmeConfig.branchObj["发电厂"]["lng"];
              }
              if (bmeConfig.branchObj && bmeConfig.branchObj["发电厂"]["lat"]) {
                element.latitude = bmeConfig.branchObj["发电厂"]["lat"];
              }
            }

            cacheList.push({
              tipID: "factoryTip-" + i,
              lng: element.longitude, //118.5602363 + (Math.random() / 50 - 10 / 1000),
              lat: element.latitude, //39.9801259 + (Math.random() / 50 - 10 / 1000),
              title: element.branch,
              num: "500",
              innerRank: element.onSite,
              outerRank: element.branchWz,
              type: element.branchId,
              branchCount: element.branchCount,
              emmissionData: emmissionData,
            });
          });
        this.cacheList = bmeConfig.emissionBubble ? cacheList : [];
        //alert(JSON.stringify(cacheList));

        this.init();

        this.$nextTick(function () {
          if ($(".ComponentTip").length > 0) {
            for (let i = 0; i < $(".ComponentTip").length; i++) {
              let jqNode = $($(".ComponentTip").get(i));
              let w = jqNode.outerWidth();
              jqNode.css("marginLeft", -w / 2 + "px");
              jqNode.find(".arrow_down").css("left", w / 2 - 20 + "px");
            }
          }
        });
      },
      deep: true,
    },
    getMaterialShedList: {
      handler(newVal, oldVal) {
        // let shedList = unref(newVal);
        // this.shedList = [];
        // this.shedList = shedList;
        // if (this.titleViews == "无组织") {
        //   this.loadShedLabel(shedList);
        // }
        /*console.log(unref(newVal));
        let newList = unref(newVal);
        let cacheList = new Array();
        newList.forEach((element, i) => {
          cacheList.push({
            tipID: "MaterialTip-" + i,
            lng: element.longitude, //118.5602363 + (Math.random() / 50 - 5 / 1000) * 2,
            lat: element.latitude, //39.9801259 + (Math.random() / 50 - 5 / 1000) * 2,
            title: element.shed_name,
            num: "500",
            innerRank: element.onSite,
            outerRank: element.branchWz,
            type: element.shed_no,
            materialType: element.type,
          });
        });
        this.cacheList_ = cacheList;

        this.init();*/
      },
      deep: true,
    },
    getShedList: {
      handler(newVal, oldVal) {
        let shedList = unref(newVal);
        this.shedList = [];
        this.shedList = shedList;
      },
      deep: true,
    },
    currentKeyPointName(newval) {
      if (this.titleViews == "无组织" && this.customerId == 38) {
        this.getBackKeyPoint(newval);
      }
    },
    titleViews(newval) {
      if(newval == "智能联动" && this.customerId == "38") {
        this.clearAllLabel();
      }
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.isUnity3D = bmeConfig.mapType === "unity3D" ? true : false;
    this.altitude =
      bmeConfig.altitude || bmeConfig.altitude === 0 ? bmeConfig.altitude : 50;
    this.flyAltitude = this.altitude < 150 ? 150 : this.altitude;
    this.init();

    if (bmeConfig.mapType === "unity3D") {
      if (this.getScreenTimer) {
        clearInterval(this.getScreenTimer);
      }
      this.getScreenTimer = setInterval(() => {
        GetScreenPosFunc();
      }, 100);
    }
    //this.renderPlay();
  },
  beforeUnmount() {
    this.$XbsjBase = this.$XbsjBase && this.$XbsjBase.destroy();
    this.$XbsjBase = new this.$XbsjBaseClass();

    if (this.getScreenTimer) {
      clearInterval(this.getScreenTimer);
    }
    if(this.customerId == "38" && this.titleViews == "无组织") {
      this.clearAllLabel();
    }
  },
  activated() {
    let that = this;
    $(document).unbind("keydown");
    $(document).bind("keydown", function (event) {
      that.selectedFactory = "";
      that.selectedMaterial = "";
      var e = event || window.event || arguments.callee.caller.arguments[0];
      if (e && e.keyCode == 27) {
        // 按 Esc
        //要做的事情
        //alert("esc");
        if (window.g_bme3dManager && window.g_bme3dManager.earth) {
          const earth = window.g_bme3dManager.earth;
          let view =
            mapViews[`mapViews_${that.customerId}`] &&
            mapViews[`mapViews_${that.customerId}`].unOrganizedMod;
          if (view && view.length) {
            window.g_bme3dManager.earth.camera.flyTo(
              view[0],
              view[1],
              view[2],
              view[3]
            );
          }
        }
      }
    });
  },
  deactivated() {
    $(document).unbind("keydown");
  },
  //方法集合
  methods: {
    init() {
      let total = this.cacheList.length;
      let total_ = this.cacheList_.length;
      this.winPos = [];
      for (let i = 0; i < total + total_; i++) {
        this.winPos.push([]);
      }

      let that = this;
      this.unorganizedScience(function () {
        that.renderPlay();
      });

      this.$coordinateTsf.cb = this.coordinateTsf_;

      // $(document).unbind("keydown");
      // $(document).bind("keydown", function (event) {
      //   console.log(e);
      //   that.selectedFactory = "";
      //   that.selectedMaterial = "";
      //   var e = event || window.event || arguments.callee.caller.arguments[0];
      //   if (e && e.keyCode == 27) {
      //     // 按 Esc
      //     //要做的事情
      //     //alert("esc");
      //     if (window.g_bme3dManager && window.g_bme3dManager.earth) {
      //       const earth = window.g_bme3dManager.earth;
      //       let view =
      //         mapViews[`mapViews_${that.customerId}`] &&
      //         mapViews[`mapViews_${that.customerId}`].unOrganizedMod;
      //       if (view && view.length) {
      //         window.g_bme3dManager.earth.camera.flyTo(
      //           view[0],
      //           view[1],
      //           view[2],
      //           view[3]
      //         );
      //       }
      //     }
      //   }
      // });
    },
    coordinateTsf_(str) {
      //console.log(str);
      let list = JSON.parse(str);
      list.forEach((item) => {
        if (item && item.length > 0) {
          let a = item[0];
          let b = a.replace(/\(/g, "").replace(/\)/g, "");
          let tmpList = b.split(",");
          this.winPos[this.cacheList.length] = new Object();
          let wR = window.screen.availWidth / 1080;
          let hR = window.screen.availHeight / 1920;

          let left = (parseFloat(tmpList[0].trim() + 0) * wR) / this.prew;
          let bottom =
            (parseFloat(tmpList[1].trim() + 0) * hR) / this.prew +
            180 / this.prew;
          console.log(left, bottom);
          this.winPos[this.cacheList.length][0] = left;
          this.winPos[this.cacheList.length][3] = bottom;
        }
      });
      this.$forceUpdate();
    },
    gotoFactoryAreaDetail(factoryId) {
      if (factoryId) {
        this.updateFactoryArea(factoryId, "", true);
        this.updateInventorySwitch(false);
        this.updateLeftRightPart(false);
        this.updateInventoryId(false);
      }
    },
    gotoFactoryArea(obj) {
      try {
        this.selectedMaterial = "";
        this.selectedFactory = obj.tipID;

        //earth.camera.flyTo(view[0], view[1], view[2], view[3]);
        let flyArg = JSON.parse(g_bme3dManager.earth.camera.toAllJSONStr());

        const earth = window.g_bme3dManager.earth;

        earth.camera.flyTo(
          [
            (obj.lng * Math.PI) / 180.0,
            (obj.lat * Math.PI) / 180.0,
            this.altitude + 90,
          ],
          this.flyAltitude + 500,
          flyArg.rotation,
          2
        );
      } catch (err) {
        console.log(err);
      }
    },
    loadShedLabel(shedArr) {
      let data = JSON.parse(JSON.stringify(shedArr));
      if (this.customerId == 38 && shedArr && Array.isArray(shedArr)) {
        data.forEach((item) => {
          var FocusPointData1 = {
            data: {
              Id: item.id.toString(),
              content: item.shed_name || item.shedName,
              longitude: item.longitude * 1,
              latitude: item.latitude * 1,
            },
          };
          ShowFocusPointFun(FocusPointData1);
        });
      }
    },
    clearAllLabel() {
      if (this.shedList && this.shedList.length > 0) {
        this.shedList.forEach((shed) => {
          let obj = {
            data: {
              Id: shed.id.toString(),
            },
          };
          CloseFocusPointFun(obj);
        });
      }
    },
    moveToShed() {
      if (this.customerId == "38" && this.titleViews == "无组织") {
        this.clearAllLabel();
        let JsonData = {
          dataList: [],
          processId: "ererererrr",
          callBackFunc: "ReturnScreenPos",
        };

        // if(this.shedObj.shedName === '永钢4号干煤棚') {
        //   this.shedObj.latitude = 31.860101;
        //   this.shedObj.longitude = 120.722729;
        // } else if (this.shedObj.shedName === '永钢2号干煤棚') {
        //   this.shedObj.latitude = 31.861664;
        //   this.shedObj.longitude = 120.725020;
        // } else if (this.shedObj.shedName === '永钢3号干煤棚') {
        //   this.shedObj.latitude = 31.863999;
        //   this.shedObj.longitude = 120.726081;
        // } else if (this.shedObj.shedName === '永钢石灰石内堆场') {
        //   this.shedObj.latitude = 31.858431;
        //   this.shedObj.longitude = 120.721954;
        // } else if (this.shedObj.shedName === '永钢热焖渣堆场') {
        //   this.shedObj.latitude = 31.866773;
        //   this.shedObj.longitude = 120.719987;
        // } else if (this.shedObj.shedName === '永钢钢渣尾渣堆场') {
        //   this.shedObj.latitude = 31.865743;
        //   this.shedObj.longitude = 120.720922;
        // } else if (this.shedObj.shedName === '三期矿粉料场') {
        //   this.shedObj.latitude = 31.867542;
        //   this.shedObj.longitude = 120.736408;
        // } else if (this.shedObj.shedName === '永钢焦炭大棚') {
        //   this.shedObj.latitude = 31.867007;
        //   this.shedObj.longitude = 120.728925;
        // } else if (this.shedObj.shedName === '二期矿粉料场') {
        //   this.shedObj.latitude = 31.868150;
        //   this.shedObj.longitude = 120.733720;
        // } else if (this.shedObj.shedName === '一期矿粉料场') {
        //   this.shedObj.latitude = 31.868040;
        //   this.shedObj.longitude = 120.730534;
        // }
        console.log(this.shedObj, 'shedObj')
        JsonData.dataList.push({
          lat: this.shedObj.latitude,
          lng: this.shedObj.longitude,
        });
        setTimeout(() => {
          // 模拟测试
          // if(this.shedObj.shedName === '永钢4号干煤棚') {
          //   CamLeapYGFunc("120.72287564252304_31.861068158130351_478.7496_6.635348_39.99997");
          // } else if (this.shedObj.shedName === '永钢2号干煤棚') {
          //   CamLeapYGFunc("120.72431117502872_31.862894072537983_650.9142_-4.06464529_33.3999634");
          // } else if (this.shedObj.shedName === '永钢3号干煤棚') {
          //   CamLeapYGFunc("120.72540169522753_31.864376608043283_394.4088_-30.6646423_36.8999634");
          // } else if (this.shedObj.shedName === '永钢石灰石内堆场') {
          //   CamLeapYGFunc("120.7214879502304_31.8582711364344_455.1754_-6.464641_39.59996");
          // } else if (this.shedObj.shedName === '永钢热焖渣堆场') {
          //   CamLeapYGFunc("120.71873905309714_31.868016520893576_648.6948_-10.7646542_26.99997");
          // } else if (this.shedObj.shedName === '永钢钢渣尾渣堆场') {
          //   CamLeapYGFunc("120.71991388289825_31.866237103747867_454.032623_-15.464654_26.69998");
          // } else if (this.shedObj.shedName === '三期矿粉料场') {
          //   CamLeapYGFunc("120.73526216709161_31.867180644677024_562.4108_-40.6646538_27.2000027");
          // } else if (this.shedObj.shedName === '永钢焦炭大棚') {
          //   CamLeapYGFunc("120.72711496766084_31.866691807235011_751.4522_-39.36465_21.7");
          // } else if (this.shedObj.shedName === '二期矿粉料场') {
          //   CamLeapYGFunc("120.73623604273375_31.869985863258709_999.0222_30.03535_18.6999969");
          // } else if (this.shedObj.shedName === '一期矿粉料场') {
          //   CamLeapYGFunc("120.73159638055658_31.871073235630377_999.0222_21.635355_19.6999969");
          // }
          CameraMove({
            longitude: this.shedObj.longitude,
            latitude: this.shedObj.latitude,
            xDeg: -8,
            yDeg: 36,
            distance: 830,
          });
        }, 100);
        setTimeout(() => {
          GetScreenPosYGFunc(JsonData);
        }, 4.5 * 1000);
        let shedList = [];
        shedList.push(this.shedObj);
        this.loadShedLabel(shedList);
        // LoadContaminatedPointFun;
      }
    },
    getBackKeyPoint(data) {
      // debugger
      try {
        this.cacheList_[0] = this.shedObj;
        let coordinateList = [];
        this.cacheList_.forEach((element, n) => {
          let cacheObj = element;
          coordinateList.push({
            lat: 39.5004009, //cacheObj["latitude"],
            lng: 118.26837658, //cacheObj["longitude"],
          });
          /*latitude: 39.5004009
                longitude: 118.26837658*/
        });
        let coordinateObj = {
          dataList: coordinateList,
          processId: "coordinate",
          callBackFunc: "coordinateCalcCB",
        };
        window.screenPosJson = JSON.stringify(coordinateObj);
        if (bmeConfig.mapType != "3D") {
          this.gotoMaterialArea(this.shedObj);
          return;
        }
      } catch (err) {
        console.log(err);
      }
    },
    gotoMaterialArea(type) {
      if(this.$store.state.customerId == 39 && type.shedName == '四车间电子料场') {
        console.log("打开四料棚")
        this.$store.commit("updateShowShed", true);
      } else {
        if (type) {
          if (type.isVDM) {
            this.updateVdmArea({
              shedId: type.shedNo,
              shedNo: type.shedNo,
              shedName: type.shedName,
              curTime: new Date().getTime(),
            });
          } else {
            this.updateMaterialArea(type);
          }

          this.updateInventorySwitch(false);
          this.updateLeftRightPart(false);
          this.updateInventoryId(false);
        }
      }
    },
    unorganizedScience(cb) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      let that = this;
      if (window.g_bme3dManager && window.g_bme3dManager.earth) {
        const earth = window.g_bme3dManager.earth;
        this.delayTimer = setTimeout(function () {
          /*let flyArg = JSON.parse(g_bme3dManager.earth.camera.toAllJSONStr());
          earth.camera.flyTo(
            [
              flyArg.position[0],
              flyArg.position[1],
              flyArg.position[2]+100,
            ],
            800,
            flyArg.rotation,
            3
          );*/

          let view =
            mapViews[`mapViews_${that.customerId}`] &&
            mapViews[`mapViews_${that.customerId}`].unOrganizedMod;
          if (view && view.length) {
            window.g_bme3dManager.earth.camera.flyTo(
              view[0],
              50,
              view[2],
              view[3]
            );
          }
          if (cb) {
            cb();
          }
        }, 500);
        /*this.delayTimer = setTimeout(function () {
          let view = mapViews[`mapViews_${that.customerId}`].unOrganizedMod;
          earth.camera.flyTo(view[0], view[1], view[2], view[3]);
          if (cb) {
            cb();
          }
        }, 5000);*/
      } else if (bmeConfig.mapType === "unity3D") {
        if (cb) {
          cb();
        }
      } else {
        that.timer = setTimeout(function () {
          that.unorganizedScience(cb);
        }, 500);
      }
    },
    renderScreenPos(areaList) {
      let jsonObj = {
        dataList: areaList,
        processId: "ererererrr",
        callBackFunc: "coordinateCalcCB",
      };
      let json = JSON.stringify(jsonObj);

      setTimeout(() => {
        this.renderScreenPos(areaList);
      }, 2000);
    },
    renderPlay() {
      let that = this;
      if (
        that.cacheList.length > 0 &&
        window.g_bme3dManager &&
        window.g_bme3dManager.earth
      ) {
        let areaList = [];
        that.cacheList.forEach((element, n) => {
          areaList.push({
            lat: element["lat"],
            lng: element["lng"],
          });
          let cacheObj = element;
          that.drawTip(
            cacheObj["tipID"],
            cacheObj["lng"],
            cacheObj["lat"],
            this.altitude,
            n,
            g_bme3dManager.earth
          );
        });
        that.$forceUpdate();
        debugger
        that.renderScreenPos(areaList);

        //物料
        that.cacheList_.forEach((element, n) => {
          let cacheObj = element;
          that.drawTip(
            cacheObj["tipID"],
            cacheObj["lng"],
            cacheObj["lat"],
            this.altitude,
            n + that.cacheList.length,
            g_bme3dManager.earth
          );
        });
        that.$forceUpdate();

        this.$nextTick(function () {
          if ($(".ComponentTip").length > 0) {
            for (let i = 0; i < $(".ComponentTip").length; i++) {
              let jqNode = $($(".ComponentTip").get(i));
              let w = jqNode.outerWidth();
              jqNode.css("marginLeft", -w / 2 + "px");
              jqNode.find(".arrow_down").css("left", w / 2 - 20 + "px");
            }
          }
        });
      } else if (bmeConfig.mapType === "unity3D") {
        console.log(2222222222222);
        let coordinateList = [];
        that.cacheList_.forEach((element, n) => {
          let cacheObj = element;
          coordinateList.push({
            lat: cacheObj["latitude"],
            lng: cacheObj["longitude"],
          });
        });
        let coordinateObj = {
          dataList: coordinateList,
          processId: "coordinate",
          callBackFunc: "coordinateCalcCB",
        };
        window.screenPosJson = JSON.stringify(coordinateObj);
      } else {
        setTimeout(function () {
          that.renderPlay();
        }, 1000);
      }
    },
    drawTip(tipID, lng, lat, height, n, earth) {
      let that = this;
      let pin = earth.sceneTree.$refs[tipID];

      if (pin) {
        let pos =
          "[" +
          lng +
          "*Math.PI/180.0, " +
          lat +
          "*Math.PI/180.0," +
          this.altitude +
          "]";
        let pos1 = eval(pos);
        let pinCzm = pin.czmObject;
        pinCzm.position = pos1;
        that.$XbsjBase.disposers.push(
          XE.MVVM.track(this, "winPos." + n, pinCzm, "winPos")
        );
        //XE.MVVM.track(this, "winPos." + n, pinCzm, "winPos");
      } else {
        let pos =
          "[" +
          lng +
          "*Math.PI/180.0, " +
          lat +
          "*Math.PI/180.0," +
          this.altitude +
          "]";
        let pos1 = eval(pos);
        var tipListObj = {
          ref: tipID,
          czmObject: {
            name: tipID,
            xbsjType: "Pin",
            position: pos1,
            near: 100,
            show: true,
            enabled: false,
          },
        };
        earth.sceneTree.root.children.push(tipListObj);
        //earth.sceneTree.$refs[tipID].enabled = false;
        let pinCzm = earth.sceneTree.$refs[tipID].czmObject;
        that.$XbsjBase.disposers.push(
          XE.MVVM.track(this, "winPos." + n, pinCzm, "winPos")
        );
        //XE.MVVM.track(this, "winPos." + n, pinCzm, "winPos");
      }
    },
    close() {
      this.selectedFactory = "";
      this.selectedMaterial = "";
      this.hoverFactory = "";
      this.$forceUpdate();
    },
    componentEnter(item, i) {
      let that = this;
      $("#factoryTip-" + i).addClass("isHover");
      if (this.factoryTimer) {
        clearTimeout(this.factoryTimer);
      }
      this.factoryTimer = setTimeout(function () {
        /*if (
          $("#factoryTip-" + i).length > 0 &&
          $("#factoryTip-" + i).find(".Component_detailInfo").length > 0
        ) {
          $("#factoryTip-" + i).css("zIndex", 1);
          $("#factoryTip-" + i)
            .find(".Component_detailInfo")
            .fadeIn(500);
        }*/
        //debugger;
        that.hoverFactory = item.tipID;
        that.$forceUpdate();
      }, 50);

      /*item.zIndex = 1;
      item.background = "rgba(255,255,255,0.55)";
      item.scale = 0.9;*/
    },
    componentOut(item, i) {
      let that = this;
      $("#factoryTip-" + i).removeClass("isHover");
      if (this.factoryTimer) {
        clearTimeout(this.factoryTimer);
      }
      this.factoryTimer = setTimeout(function () {
        /*let className = $("#factoryTip-" + i)
          .find(".ComponentTip")
          .attr("class");
        if (
          $("#factoryTip-" + i).length > 0 &&
          $("#factoryTip-" + i).find(".Component_detailInfo").length > 0 &&
          className.indexOf("isSelected") < 0
        ) {
          $("#factoryTip-" + i).css("zIndex", "initial");
          $("#factoryTip-" + i)
            .find(".Component_detailInfo")
            .fadeOut(500);
        }*/
        that.hoverFactory = "";
        that.$forceUpdate();
      }, 500);
      /*item.zIndex = 0;
      item.background = "rgba(180, 180, 180, 0.533)";
      item.scale = 0.8;*/
    },
  },
};
</script>
<style lang="scss">
.isSelected {
  .Component_detailInfo {
    display: block !important;
  }
}
.closeBut {
  position: absolute;
  cursor: pointer;
  right: -6px;
  width: 30px;
  height: 40px;
}
.Component_detailInfo {
  top: -340px;
  left: -240px;
  .component_tip {
    font-size: 14px;
    left: 23px;
    position: absolute;
    top: -8px;
  }
  .component_rank {
    font-size: 18px;
    font-family: "fontNormal";
    font-weight: 400;
    color: #c8dde1;
    line-height: 40px;
    text-align: left;
    padding-left: 170px;
  }
  .component_btn {
    height: 35px;
    line-height: 35px;
    background: linear-gradient(
      180deg,
      rgba(104, 125, 191, 0.53) 0%,
      rgba(103, 178, 229, 0.13) 44%,
      rgba(149, 203, 237, 0.13) 60%,
      rgba(0, 16, 108, 0.13) 100%
    );
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.22);
    font-size: 16px;
    font-family: "fontNormal";
    font-weight: 400;
    color: #ffffff;
    text-align: center;
    position: absolute;
    padding: 0 15px;
    right: 20px;
    bottom: 0px;
    cursor: pointer;
    border-radius: 3px;
    border: 1px solid rgba(28, 247, 255, 1);
  }
}
.component_table {
  border-collapse: collapse;
  width: 720px;
  position: relative;
  margin: 20px auto;
  th {
    font-size: 16px;
    background: rgba(1, 18, 43, 0.5);
    border: 1px solid rgba(132, 170, 255, 0.5);
    height: 44px;
    line-height: 44px;
    text-align: center;
  }

  td {
    font-size: 16px;
    background: rgba(1, 18, 43, 0.5);
    border: 1px solid rgba(132, 170, 255, 0.5);
    height: 44px;
    line-height: 44px;
    text-align: center;
  }
}
</style>
<style lang="scss" scoped="scoped">
.component_up {
  position: relative;
}
.component_down {
  position: relative;
}
.Component_detailInfo {
  position: absolute;
  width: 769px;
  height: 326px;
  background: rgba(0, 0, 0, 0.8);
  box-shadow: 0px 10px 20px 0px rgba(74, 144, 226, 0.31);
  border-radius: 16px;
  display: none;
  border: 1px solid #4a90e2;
}

.arrow_down {
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-top: 20px solid rgba(0, 0, 0, 0.8);
  position: absolute;
  top: 74px;
  left: 120px;
}

.test {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  overflow: hidden;
  ul {
    width: 100%;
    height: 100%;
    pointer-events: none;
    .ComponentTipLi {
      position: absolute;
      pointer-events: auto;
    }

    .defaultClass {
      opacity: 0.7 !important;
    }
    .isHover > .ComponentTip {
      opacity: 0.8 !important;
    }
    .isSelected {
      opacity: 0.9 !important;
    }
    .ComponentTip {
      // background:  url('./img/1.png') no-repeat;
      background-size: 100% 100%;
      opacity: 0.7;
      //background: rgba(25, 45, 180, 0.5);
      //border: 1px solid #fff;
      //width: 400px;
      //height: 160px;
      height: 75px;
      margin-left: -140px;
      position: relative;
      pointer-events: auto;
      //border-radius: 10px;
      padding: 10px 30px;
      font-size: 24px;
      //background: rgba(180, 180, 180, 0.533);
      //transform: scale(0.8);
      transform-origin: center center;
      color: #fff;
      //box-shadow: 7px 9px 6px #0000002e;

      background: rgba(0, 0, 0, 0.8);
      //box-shadow: 0px 10px 20px 0px rgba(74, 144, 226, 0.31);
      box-shadow: 0px 10px 20px 0px rgba(74, 144, 226, 0.31);
      border-left: 1px solid #4a90e2;
      border-top: 1px solid #4a90e2;
      border-right: 1px solid #4a90e2;
      z-index: 9;

      p {
        //color: #fff;
        //font-weight: 550;
        font-weight: 400;
        color: #f5a623;
        padding: 6px 0;
        font-size: 32px;
      }
      span {
        font-weight: 400;
        color: #f5a623;
      }
    }
    /*.ComponentTip:before {
      content: "";
      position: absolute;
      z-index: 1;
      top: 0;
      left: -10%;
      width: 75%;
      height: 100%;
      background: white;
      opacity: 0.15;
      -webkit-transform-origin: center center;
      -ms-transform-origin: center center;
      transform-origin: center center;
      -webkit-transform: skew(-30deg) scaleY(1) translate(0, 0);
      -ms-transform: skew(-30deg) scaleY(1) translate(0, 0);
      transform: skew(-30deg) scaleY(1) translate(0, 0);
      -webkit-transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
      transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
    }*/
    .MaterialTipLi {
      position: absolute;
      pointer-events: auto;
    }
    .MaterialTip {
      height: 75px;
      margin-left: -140px;
      position: relative;
      pointer-events: auto;
      font-size: 24px;
      box-shadow: rgb(0 0 0 / 65%) 5px 5px 4px;
      left: 2093.87px;
      bottom: 630.11px;
      background: rgba(180, 180, 180, 0.533);
      padding: 28px;
      border-radius: 120px;
      overflow: hidden;
      img {
        width: 80px;
        height: 80px;
        margin: auto;
        padding: 10px 5px;
      }
      span {
        font-size: 24px;
        color: #000;
        font-weight: bolder;
      }
    }
    /*.MaterialTip:before {
      content: "";
      position: absolute;
      z-index: 1;
      top: 0;
      right: -17%;
      width: 50%;
      height: 100%;
      background: white;
      opacity: 0.15;
      -webkit-transform-origin: center center;
      -ms-transform-origin: center center;
      transform-origin: center center;
      -webkit-transform: skew(-30deg) scaleY(1) translate(0, 0);
      -ms-transform: skew(-30deg) scaleY(1) translate(0, 0);
      transform: skew(-30deg) scaleY(1) translate(0, 0);
      -webkit-transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
      transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
    }*/
  }
}
.button {
  width: 30px;
  height: 30px;
  background-color: red;
  pointer-events: all;
}
</style>
